import Marksheet from './Marksheet'

const exportObj = {
    Marksheet
}

export default exportObj